import { personalizedSlipSchema } from "@redotech/redo-fulfillment-operations-common/personalized-slip/personalized-slip-definition";
import * as z from "zod";

export const updatePersonalizedSlipTemplate = {
  name: "updatePersonalizedSlipTemplate" as const,
  input: personalizedSlipSchema,
  // Additive so callers typed to the template alone keep working.
  output: z.intersection(
    personalizedSlipSchema,
    z.object({
      /** Unprinted inserts queued for regeneration by this save. */
      regeneratingInsertCount: z.number().nullish(),
    }),
  ),
};
